module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/linkexpire/linkexpire.component.css
// module id = ./src/app/linkexpire/linkexpire.component.css
// module chunks = main